export default "__VITE_ASSET__pOe1n3KV__"